import { api } from "./api";

// Thin client for the backend accounts API (/api/accounts). Every call attaches
// the Firebase ID token via the axios interceptor in ./api. The backend does all
// the privileged work (create logins, membership, send reset emails) with the
// Admin SDK; the browser only orchestrates.

// ── Studio admin ──────────────────────────────────────────────────────────────
export const listAccounts = () => api.get("/api/accounts").then((r) => r.data);

// Create an account with its first owner. Pass an existing user (ownerUid) OR a
// new login (ownerEmail [+ ownerDisplayName] [+ ownerPassword]).
export const createAccount = (payload) =>
  api.post("/api/accounts", payload).then((r) => r.data);

// Destructive: delete an account + its projects/requests/bookings and purge its
// member logins (admins are detached, not deleted). Admin only.
export const deleteAccount = (accountId) =>
  api.delete(`/api/accounts/${accountId}`).then((r) => r.data);

// ── Any member ────────────────────────────────────────────────────────────────
export const getAccount = (accountId) =>
  api.get(`/api/accounts/${accountId}`).then((r) => r.data);

export const listMembers = (accountId) =>
  api.get(`/api/accounts/${accountId}/members`).then((r) => r.data);

// ── Owner (or admin) ──────────────────────────────────────────────────────────
// Add a teammate: creates/links their login and adds them at `role`
// (owner|editor|viewer). Pass `password` to set an initial temp password the
// person can sign in with immediately (shared out-of-band).
export const addMember = (accountId, { email, displayName, role, password }) =>
  api
    .post(`/api/accounts/${accountId}/members`, { email, displayName, role, password })
    .then((r) => r.data);

export const updateMemberRole = (accountId, uid, role) =>
  api.patch(`/api/accounts/${accountId}/members/${uid}`, { role }).then((r) => r.data);

// Set a new temp password for an existing member (re-enables a disabled login).
export const setMemberPassword = (accountId, uid, password) =>
  api.patch(`/api/accounts/${accountId}/members/${uid}`, { password }).then((r) => r.data);

export const removeMember = (accountId, uid) =>
  api.delete(`/api/accounts/${accountId}/members/${uid}`).then((r) => r.data);

export const resendInvite = (accountId, uid) =>
  api.post(`/api/accounts/${accountId}/members/${uid}/resend`).then((r) => r.data);

export const ACCOUNT_ROLES = ["owner", "editor", "viewer"];
